import React, { useState, useEffect}  from 'react';
import { DataContext } from '../App';
import { Bar } from "react-chartjs-2";
import {
    LineElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
    PointElement
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend
);

ChartJS.register(annotationPlugin);

const {getPadding, average, min, max} = require('../utils.js');

function PressureContext() {
    const data = React.useContext(DataContext);
   
    // labels - @TO_DO - now coming from Julia but need to create them here based on the forecast timestamp
    // pad with "" on both ends, also remove value for current month with slice()
    var monthnames = data.monthnames;
    monthnames = getPadding(1, "").concat(monthnames)// .concat(getPadding(1, ""));

    // data - padded as above with NaNs
    var monthly_avg = data.monthly_avg;
    var monthly_avg_max = max(monthly_avg)
    monthly_avg = getPadding(1, NaN).concat(monthly_avg)//.concat(getPadding(1, NaN));

    // annotation value
    var last_14_day_average = average(data.historical_daily_fruit_fly_pressure);

    // variable font size depending on the screen size
    const [windowWidth, setWindowWidth] = useState(0);
    const updateDimensions = () => {
        const windowWidth = window.innerWidth
        setWindowWidth(windowWidth)
    }
    useEffect(() => { 
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize",updateDimensions);
    }, []);
    
    const fs = windowWidth > 1600 ? 12 : 8;

    const chartdata = {
        labels: monthnames,
        datasets: [
            {
                data: monthly_avg,
                backgroundColor: getPadding(9,'#282878'),
                borderRadius: 10,
                borderSkipped: false,
                datalabels: {
                    display: function(context) {
                        return context.dataset.data[context.dataIndex] === monthly_avg_max // display labels on max value
                        // return context.dataIndex % 2; // display labels with an odd index
                    },
                    color: 'black',
                    formatter: function(value, context) {
                        return value.toFixed(2);
                    },
                    anchor: 'end',
                    align: 'end',
                    font: {
                        size: fs
                    }
                }
            }
        ]
    };
    
    const options = {
        layout: {
            padding: {
                left: 20,
                right: 20
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                max: max([monthly_avg_max, last_14_day_average]) + 1,
                min: -1,
                grid: {
                    display: false,
                    borderColor: '#FFFFFF',
                    drawTicks: false
                },
                ticks: {
                    display: false,
                }
            },
            x: {
                grid: {
                    display: false,
                    borderColor: '#FFFFFF',
                    drawTicks: false
                },
                ticks: {
                    display: true,
                    maxRotation: 45,
                    minRotation: 45
                }
            }
        },
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        plugins: {
            tooltip: {
                enabled: false
            },
            legend: {
                display: false
            },
            autocolors: false,
            annotation: {
                annotations: {
                    annotation1: {
                        type: 'line',
                        borderColor: '#860B0B',
                        drawTime: 'afterDatasetsDraw',
                        borderWidth: 2.0,
                        // borderDash: [6, 4],
                        label: {
                            enabled: true,
                            content: 'Current level: ' + last_14_day_average.toFixed( 2),
                            position: 'start',
                            rotation: 0,
                            yAdjust: 18,
                            xAdjust: -5,
                            font: {
                                size: fs
                            },
                        },
                        scaleID: 'y',
                        value: last_14_day_average
                    },
                },
            }
        }
    };

    return(
        <div className="card-body">
            <div style={{height:"180px"}}>
                <Bar
                    plugins={[ChartDataLabels]}
                    data={chartdata}
                    options={options}
                />
            </div>
        </div>

    );

}

export default PressureContext;